var Equipment = {
	collectibles: [],
	erp: null,
	delivered: {},
	deliveredCount: 0,
	opened: false,
	tweens: {},

	init: function() {
		this.erp = new Interpolate();

		this.widget = $("<div class='eq-widget'>Ekwipunek</div>");
//		this.eq = $("<div id='eq' class='eq'><div class='inventory'><span>Przedmioty w plecaku</span><div class='items'></div><a href='javascript:void(null);' class='eq-close'>&times;</a></div></div>");
		this.eq = $("<div id='eq' class='eq'><div class='inventory'><div class='items'></div></div></div>");
		this.inv = this.eq.find(".inventory .items");
		this.collection = this.eq.find(".collection");

		$("#overlay").append(this.widget);
		$("#panels").append(this.eq);

		$("#eq .eq-close").click(this.close.bind(this));

		this.widget.click(this.toggle.bind(this));

		this.sounds = {
			"open": new AudioEffect("assets/audio/games/backpack.mp3"),
			"deliver": new AudioEffect("assets/audio/games/delivered.mp3")
		};
		this.sounds.open.setVolume(0.7);
	},

	vibrate: function() {
		this.erp.setStart({"scale": 0.8});
		this.erp.setEnd({"scale": 1});
		this.erp.reset();

		this.vibrating();
	},

	vibrating: function() {
		if (this.erp.pos <= 1) {
			this.erp.next(0.1);
			var s = this.erp.cycleProperty("scale", "easeOutElastic");
			this.widget.find("img").css("transform", "scale(" + s + ", " + s + ")");

			setTimeout(this.vibrating.bind(this), 16);
		}
	},

	has: function(c) {
		for(var r in this.collectibles) {
			var inv = this.collectibles[r];
			if (inv.id == c.id) return true;
		}

		return false;
	},

	showWidget: function() {
		this.widget.show();
		this.widget.html("<div class='label'><b>Plecak</b><br><small>Przedmioty:" + (this.collectibles.length - this.deliveredCount) + "</small></div><img src='assets/games/backpack.png?1234' width='180'>");
		this.widget.addClass("show");
	},

	showGhost: function() {
		this.widget.show();
		this.widget.html("<img src='assets/games/backpack.png?1234' width='180'>");
		if (this.tweens['bpout'] != undefined) clearTimeout(this.tweens['bpout']);

		if (this.tweens['bpin'] == undefined) this.tweens['bpin'] = setTimeout(function() { this.widget.addClass("show"); this.tweens['bpin'] = undefined;}.bind(this), 100);
		this.tweens['bpout'] = setTimeout(function() { this.widget.removeClass("show"); this.tweens['bpout'] = undefined;}.bind(this), 2000);
	},

	collect: function(col) {
		ItemState.setState(col, 'picked');

		if (QuestManager.action('collected', col)) {
			this.collectibles.push(col);
			this.showWidget();

			if (this.opened) this.refreshInventory();
		} else {
			Equipment.showGhost();
		}
	},

	dropPosition: function() {
		var ofs = this.widget.offset();
		var hw = this.widget.width() * 0.5 + 80;
		var h = this.widget.height();

		return {"x": parseInt(ofs.left) + hw, "y": parseInt(ofs.top) + h};
	},

	close: function() {
		this.opened = false;

		var maxel = this.collectibles.length * 100;
		var del = maxel;
		for(var r in this.collectibles) {
			var c = this.collectibles[r];
			del -= 100;
			setTimeout(function() {
				this.node.removeClass("backpacked");
			}.bind(c), del);
		}

		setTimeout(function() {
			this.eq.hide();
		}.bind(this), maxel);
	},

	refreshInventory: function() {
		this.inv.html("");
		this.collection.html("");
		var left = 0;
		var top = 0;

		for(var r in this.collectibles) {
			var c = this.collectibles[r];

			if (Equipment.delivered[c.id] != undefined) continue;

			c.no = r;
			c.node = $("<div class='carried'><span class='eqc-label'>" + c.title + "</span><img src='/storage/collectibles/" + c.icon + "' width='80'></div>");
			this.enableDnD(c);
			this.inv.append(c.node);
		}


		var del = this.collectibles.length * 100;
		for(var r in this.collectibles) {
			var c = this.collectibles[r];
			del -= 100;
			setTimeout(function() {
				this.node.addClass("backpacked");
			}.bind(c), del);
		}
	},

	toggle: function() {
		if (this.opened) this.close();
		else this.open();
	},

	open: function() {
		this.eq.show();
		this.sounds.open.play();
		this.opened = true;

		this.dragging = null;

		this.refreshInventory();
	},

	dragDelivered: function() {
		Equipment.dragging.node.remove();
		Equipment.delivered[Equipment.dragging.id] = true;
		ItemState.setState(Equipment.dragging, 'delivered');

		this.deliveredCount ++;
		this.showWidget();

		if (this.deliveredCount >= this.collectibles.length) this.close();

		QuestManager.action('delivered', Equipment.dragging);

		this.sounds.deliver.play();
	},

	enableDnD: function(c) {
		c.node.on("mousedown", function(e) {

			this.dragging = c;

			c.drag = $("<div style='position: absolute;transform: translate(-50%, -50%);z-index:999999;pointer-events:none;'><img src='/storage/collectibles/" + c.icon + "' width='150'></div>");
			$("body").append(c.drag);

			c.gx = e.clientX;
			c.gy = e.clientY;
			c.drag.css("left", e.clientX);
			c.drag.css("top", e.clientY);

			$("body").one("mouseup.gdrag", function(e) {
				c.drag.remove();
				this.dragging = null;

				$("body").off("mousemove.gdrag");
				e.stopPropagation();
				e.preventDefault();
			}.bind(this));

			
			$("body").on("mousemove.gdrag", function(e) {
				c.drag.css("left", e.clientX);
				c.drag.css("top", e.clientY);
			}.bind(this));
			
			e.stopPropagation();
			e.preventDefault();
		}.bind(this));
	},

	resetQuestItems: function(q) {
		var nc = [];
		var tmp = {};

		for(var c in Equipment.collectibles) {
			var col = Equipment.collectibles[c];
			if (col.collection_id != q.id) {
				nc[c] = col;
				tmp[col.id] = q.id;
			}
		}
		Equipment.collectibles = nc;
		
		var dv = {};
		this.deliveredCount = 0;
		for(var c in Equipment.delivered) {
			if (tmp[c]) {
				dv[c] = true;
				this.deliveredCount ++;
			}
		}

		Equipment.delivered = dv;
		
		this.showWidget();
	}
}

PluginManager.add(Equipment);